export default "<app-sidenav></app-sidenav>\n<app-footer></app-footer>\n<!-- <router-outlet></router-outlet> -->"